'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportNativeAnswer = supportNativeAnswer;
exports.supportNativeGallery = supportNativeGallery;
exports.supportPopCommentQbUrl = supportPopCommentQbUrl;
exports.supportNestedComments = supportNestedComments;
exports.supportNativeComment = supportNativeComment;
exports.supportNativeFeedback = supportNativeFeedback;
exports.supportAloneCommentPage = supportAloneCommentPage;
exports.supportSubscription = supportSubscription;
exports.supportFeeds = supportFeeds;
exports.supportArticleSingleWebview = supportArticleSingleWebview;
exports.supportVideoSniff = supportVideoSniff;
exports.supportFusion = supportFusion;
exports.supportGoodsPicView = supportGoodsPicView;
exports.supportPushCardMode = supportPushCardMode;
exports.supportShareHotCardMode = supportShareHotCardMode;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _UA = require('./UA');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 是否支持回答页固定头部
 * @param {Number} version
 */
/*
 * @Author: edvardchen
 * @Date:   2017-05-04 15:09:09
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-05-20 11:34:51
 */

function supportNativeAnswer(version) {
  return version > 79;
}

// 终端7.5以后支持终端图集
function supportNativeGallery(version) {
  return version > 74;
}

/**
 * 8.2才支持暂态页面的qb地址
 * @param  {Number} version=0
 */
function supportPopCommentQbUrl() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return version > 81;
}

/**
 * 是否支持楼中楼评论
 * @param {Number} version
 */
function supportNestedComments(version) {
  return version > 80;
}

/**
 * 6.6 开始支持终端评论框
 * @param {Number} version
 */
function supportNativeComment(version) {
  return version > 65;
}

/**
 * 资讯框架右上角（三个点）是否可以举报
 * @param {Number} version
 */
function supportNativeFeedback(version) {
  return version > 72;
}

/**
 * 是否支持独立评论
 * @param {Number} version   终端版本号
 * @param {String} userAgent
 * @param {Boolean} directAccess 是否直接从地址栏访问
 */
function supportAloneCommentPage(version, userAgent, directAccess) {
  if (directAccess) {
    if ((0, _UA.isIOS)(userAgent)) {
      return version >= 80; // 8.0 iOS 才开始支持地址栏直接访问
    }
  }
  return version > 74;
}

/**
 * 是否支持订阅tag
 * @param  {Number} version
 * @return {Boolean}
 */
function supportSubscription(version) {
  return version > 65;
}

/**
 * 是否首页支持feeds
 * @param  {Number} version
 */
function supportFeeds(version) {
  return version > 74;
}

/**
 * 是否支持正文单webview
 * @param  {Number} version
 * @return {Boolean}
 */
function supportArticleSingleWebview(version) {
  return version > 70;
}

/**
 * 是否支持终端嗅探
 * @param  {Number} version
 * @return {Boolean}
 */
function supportVideoSniff(version) {
  return version > 63;
}

/**
 * 判断是否支持融合框架
 * @param  {String} qua2
 * @return {Boolean}
 */
function supportFusion(qua2) {
  var _querystring$parse = _queryString2.default.parse(qua2),
      VN = _querystring$parse.VN,
      PPVN = _querystring$parse.PPVN;

  var version = VN || PPVN;
  if (!version) {
    return false;
  }
  try {
    var versionNum = parseInt(version.split('.').slice(0, 3).join('').slice(0, 3), 10);
    return versionNum >= 741;
  } catch (e) {
    console.error(e);
    return false;
  }
}
/** *
 * 判断是否支持商品图片查看器
 * @param  {Number} version
 * @return {Boolean}
 */
function supportGoodsPicView(version) {
  return version >= 86;
}
/** *
 * 判断是否支持PUSH卡片样式
 * @param  {Number} version
 * @return {Boolean}
 */
function supportPushCardMode(version) {
  return version >= 93;
}
/** *
 * 判断是否支持分享、热词卡片样式
 * @param  {Number} version
 * @return {Boolean}
 */
function supportShareHotCardMode(version) {
  return version >= 93;
}